export default {
    data() {
        return {
            mainActiveTab: 'simulator-questions',
        }
    }
}